[
  {
    "code": "SV-AH",
    "name": "Ahuachapán"
  },
  {
    "code": "SV-CA",
    "name": "Cabañas"
  },
  {
    "code": "SV-CH",
    "name": "Chalatenango"
  },
  {
    "code": "SV-CU",
    "name": "Cuscatlán"
  },
  {
    "code": "SV-LI",
    "name": "La Libertad"
  },
  {
    "code": "SV-PA",
    "name": "La Paz"
  },
  {
    "code": "SV-UN",
    "name": "La Unión"
  },
  {
    "code": "SV-MO",
    "name": "Morazán"
  },
  {
    "code": "SV-SM",
    "name": "San Miguel"
  },
  {
    "code": "SV-SS",
    "name": "San Salvador"
  },
  {
    "code": "SV-SV",
    "name": "San Vicente"
  },
  {
    "code": "SV-SA",
    "name": "Santa Ana"
  },
  {
    "code": "SV-SO",
    "name": "Sonsonate"
  },
  {
    "code": "SV-US",
    "name": "Usulután"
  }
]